import React, { useEffect } from "react";
import styles from './index.css';
import datePickerStyles from "react-day-picker/style.css";

import { createRoot } from "react-dom/client";
import OlympicSearch from "./widgets/olympicSearch.jsx";
import root from 'react-shadow';

const mountNodes = document.querySelectorAll("[data-search-form]");
mountNodes.forEach(mountNode => {
  var usePortal = mountNode.dataset.searchUseportal == "true";
  let overviewNode = null;
  if (usePortal) {
    overviewNode = document.querySelector("[data-search-overview]");
  }


  createRoot(mountNode).render(<root.div >
    <OlympicSearch
      overviewNode={overviewNode}
      baseUrl={mountNode.dataset.baseUrl}
      bookingEngineBaseUrl={mountNode.dataset.bookingEngineBaseUrl}
      specificSearch={JSON.parse(mountNode.dataset.specificSearch ?? null)}
      specificAccom={JSON.parse(mountNode.dataset.specificAccom ?? null)}

    />
      <style type="text/css">{styles}</style>
      <style type="text/css">{datePickerStyles}</style>
  </root.div> 
  );
}); 
window.OlympicSearch = ({mountNode, overviewNode, baseUrl, bookingEngineBaseUrl, specificSearch}) => {
  createRoot(mountNode).render(<root.div >
    <OlympicSearch
      overviewNode={overviewNode}
      baseUrl={baseUrl}
      bookingEngineBaseUrl={bookingEngineBaseUrl}
      specificSearch={specificSearch}
    />
    <style type="text/css">{styles}</style>
    <style type="text/css">{datePickerStyles}</style>
  </root.div>
  );
} 